<template>
  <transition name="el-loading-fade">
    <div v-show="data.visible" class="loading-mask">
      <div class="loading-spinner row-center">
        <div ref="refLoading" :style="iconStyle"></div>
        <span class="loading-text">{{ loadingText }}</span>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import lottie from 'lottie-web'
import animationData from '/@/assets/lottie/loading.json'


const props = defineProps({
  loadingText: {
    type: String,
    default: '加载中...'
  },
  iconSize: {
    type: Number,
    default: 32
  }
})

const afterLeaveFlag = ref(false)
const data = reactive({
  visible: false,
})

const iconStyle = computed(() => {
  const { iconSize } = props || {}
  const size = Math.abs(iconSize || 32)

  return {
    width: `${size}px`,
    height: `${size}px`
  }
})

const refLoading = ref()

const init = () => {
  lottie.loadAnimation({
    container: refLoading.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData
  })
}

const handleAfterLeave = (cb) => {
  afterLeaveFlag.value = true

  debounceHandleAfterLeave(cb)
}

const debounceHandleAfterLeave = useDebounceFn((cb: Fn) => {
  if (!afterLeaveFlag.value) return

  afterLeaveFlag.value = false
  cb()
}, 400)

const showLoading = () => {
  data.visible = true
}

const closeLoading = (cb: Fn) => {
  handleAfterLeave(cb)

  data.visible = false
}

onMounted(() => {
  init()
})


defineExpose({
  showLoading,
  closeLoading
})
</script>

<style scoped lang="scss">
.loading-mask {
  position: absolute;
  z-index: 2000;
  margin: 0;
  inset:0;
  background-color: var(--el-mask-color);
  transition: opacity var(--el-transition-duration);
}

.loading-spinner {
  top: 50%;
  // margin-top: calc((0px - 32px) / 2);
  transform: translateY(-50%);
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
}

.loading-text {
  @apply ml-4 text-[#{var(--ba-text-color-regular)}]
}
</style>
